import {pickAll} from 'ramda'

import {BookingData} from '@daedalus/core/src/booking/types/BookingData'
import {getIsPayAtPropertyMoR} from '@daedalus/core/src/offer/business/getIsPayAtPropertyMoR'
import {Offer} from '@daedalus/core/src/offer/types/offer'

/**
 * Generate a fake offer from BoVio API booking data
 */
export const getOfferFromBookingData = (
  bookingResponse: BookingData
): Offer => {
  const isPayAtPropertyMor = getIsPayAtPropertyMoR(bookingResponse)
  const isPayAtProperty = !!bookingResponse.payAtProperty

  // TODO (@Checkout): it is not clear which of these is actually needed, consider figuring out and cleaning up
  const canPayLater = isPayAtPropertyMor || isPayAtProperty

  return {
    ...pickAll(
      [
        'refundable',
        'prices',
        'merchantOfRecord',
        'cancellationPenalties',
        'providerCode'
      ],
      bookingResponse
    ),
    canPayLater
  }
}
